import { KeyValue } from '@/main/models/common';
import {
  FileTypeActionTypes,
  FileTypeTypes
} from '@/main/store/fileType/fileTypeTypes';

export function getFileType(idSystemApplication: number): FileTypeActionTypes {
  return {
    type: FileTypeTypes.GET_FILE_TYPE,
    payload: { idSystemApplication }
  };
}

export function saveFileType(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): FileTypeActionTypes {
  return {
    type: FileTypeTypes.SAVE_FILE_TYPE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerFileType(): FileTypeActionTypes {
  return {
    type: FileTypeTypes.RESET_REDUCER_FILE_TYPE
  };
}
